<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1" v-if="this.$store.state.navlist">
      <div class="wp" v-if="this.$store.state.navlist[4]">
        <div class="cur">
          <router-link to="/" tag="a">{{ $t("homeTxt") }}</router-link>
          &gt; <span>{{ this.$store.state.navlist[4].name }}</span>
        </div>
        <ul class="ul-snv-r" v-if="this.$store.state.navlist[4].sub">
          <li
            :class="[item.cid === curId ? 'on' : '']"
            v-for="(item, index) in this.$store.state.navlist[4].sub"
            :key="index"
          >
            <template v-if="item.url != '/case' && item.show">
              <a class="v2" @click="changeId(item.cid)">{{ item.name }}</a>
            </template>
            <template v-if="item.url == '/case' && item.show">
              <a class="v2" @click="toCase">{{ item.name }}</a>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <div class="box-pict">
      <div class="wp">
        <div class="m-detb1">
          <h1>{{ result && result.serviceHeader1 }}</h1>
          <div class="txt">
            <div class="p-tit">
              {{ result && result.remarks }}
            </div>
            <div v-if="serviceText1.length">
              <p v-for="(item, index) of serviceText1" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="p-tit">{{ result && result.serviceHeader2 }}</div>
            <div v-if="serviceText2.length">
              <p v-for="(item, index) of serviceText2" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="p-tit">{{ result && result.serviceHeader3 }}</div>
            <div v-if="serviceText3.length">
              <p v-for="(item, index) of serviceText3" :key="index">
                <template v-if="(item.length!=0)">
                  {{ item }}
                </template>
                <template v-else>
                  <br/>
                </template>
              </p>
            </div>
          </div>
        </div>
        <ul class="ul-listw1" v-if="introShow && serviceImgs.length > 0">
          <li v-for="(item, index) of serviceImgs" :key="index">
            <div class="con">
              <div class="pic">
                <img :src="imageUrl + item" />
              </div>
              <div class="txt">
                <div class="desc">
                  {{ serviceTexts[index] }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  <!-- :style="'background-image: url(' + imageUrl + carouselBg + ');'" -->
    <div
      class="f-ban"
      
      v-if="carouselShow"
    >
   <img :src="imageUrl+carouselBg" alt="" class="rowbg">
      <div class="wp">
        <div class="g-ad-tit">
          <div class="tit1">{{ result && result.carouselTitle }}</div>

          <div class="m-adv" v-if="carousels.length > 0">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) of carousels"
                  :key="index"
                >
                  <div class="item">
                    <div class="pic">
                      <img :src="imageUrl + item" alt="" />
                    </div>
                    <div class="txt">
                      <div class="tit">{{ carouselTitles[index] }}</div>
                      <div
                        class="desc"
                        :class="[
                          carouselTexts[index].length > strlen ? 'len' : '',
                        ]"
                      >
                        {{ carouselTexts[index] }}
                      </div>
                      <p class="open moretxt">{{ more }}</p>
                      <p class="hide moretxt">{{ more1 }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper';

import { Loading } from 'element-ui';
export default {

  data () {
    return {
      loading: true,
      result: null,
      Res: {},
      serviceText1: [],
      serviceText2: [],
      serviceText3: [],
      carousels: [],
      carouselTexts: [],
      carouselTitles: [],
      serviceImgs: [],
      serviceTexts: [],
      carouselBg: '',
      isService: '服务',
      curId: '',

      strlen: 96,
      more: '展开',
      more1: '收起',

      carouselShow: 1, //轮播开关
      introShow: 1, //服务4个图片开关
      pageInfo: {
        zhId: '1436517197878366209',
        enId: '1436463331191189505'
      }
    }
  },
  mounted () {

  },
  created () {
    let that = this;
    /* if (that.$i18n.locale === 'zh') {

      that.isService = '服务';
      that.strlen = 96
      that.more = '展开'
      that.more1 = '收起'
    } else if (that.$i18n.locale === 'en') {
      that.isService = 'Service';
      that.strlen = 192
      that.more = 'Expand'
      that.more1 = 'Collapse'
    } */
    that.isService = 'Service';
    that.strlen = 192
    that.more = 'Expand'
    that.more1 = 'Collapse'
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      Loading.service();
      let serid = to.params.id || localStorage.getItem('serId');
      // let serid = to.params.id || localStorage.getItem('serId') || $storeId;
      // console.log('ss',serid);
      if (serid) {
        vm.$store.commit('changeServiceId', serid);
        localStorage.setItem('serId', serid)
        vm.curId = serid
        vm.getServiceTj(serid);
      }
    });
  },

  computed: {
    mapboxMap () {
      return this.$store.state.serviceId
    },
    mapboxMap1 () {
      return this.$store.state.navlist
    }

  },
  watch: {
    mapboxMap (newData, oldData) {
      this.curId = newData
      this.getServiceTj(newData);
      window.scroll(0, 0);
    },
    /* '$i18n.locale' (newValue) {
      this.$router.push('/');
    }, */
    '$route': 'setLocal',
  },
  methods: {
    setLocal () {

    },
    changeId (id) {
      let that = this, serid = id;
      localStorage.setItem('serId', serid);
      that.$store.commit('changeServiceId', serid);
    },
    toCase () {
      this.$router.push('case');
    },
    initSwiper () {
      new Swiper('.m-adv .swiper-container', {
        slidesPerView: 3,
        observer: true, observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 轮播响应式，屏幕尺寸小于767，显示1个。小于960显示2个，小于1199显示3个
        breakpoints: {
          767: {
            slidesPerView: 1,
          },
          960: {
            slidesPerView: 2,
          },
          1199: {
            slidesPerView: 3,
          }
        }
      });
    },

    getServiceTj (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getServiceTj(data)
        .then((res) => {
          if (res.code == 200) {
            // console.log(res);
            let result = res.result;
            that.result = result;
            Loading.service().close();
            // 介绍文字
            that.serviceText1 = result.serviceText1 ? result.serviceText1.split('\n') : [];
            that.serviceText2 = result.serviceText2 ? result.serviceText2.split('\n') : [];
            that.serviceText3 = result.serviceText3 ? result.serviceText3.split('\n') : [];
            // 服务优势
            that.carousels = result.carousels ? result.carousels.split(',') : [];
            that.carouselTexts = result.carouselTexts ? result.carouselTexts.split('\n') : [];
            that.carouselTitles = result.carouselTitles ? result.carouselTitles.split('\n') : [];
            // 文字介绍的4个小图片
            that.serviceImgs = result.serviceImgs ? result.serviceImgs.split(',') : [];
            that.serviceTexts = result.serviceTexts ? result.serviceTexts.split('\n') : [];
            that.carouselBg = result.carouselBg
            that.carouselShow = result.carouselShow
            that.introShow = result.introShow
            that.$nextTick(function () {
              that.initSwiper();
            })
          } else {
            that.result = null
            Loading.service().close();
          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },

  },

}
</script>

<style>
</style>